import api from "../../api/index";

const getdashboard = `${process.env.VUE_APP_BASE_URI}/users/dashboard`;

const getDefaultState = () => {
  return {
    dashboard: [],
    status: "",
    isShowTermsAndConditions: false,
    showRebrand: false,
  };
};

const state = getDefaultState();

const getters = {
  dashboard: (state) => state.dashboard,
  isShowTermsAndConditions: (state) => state.isShowTermsAndConditions,
  showRebrand: (state) => state.showRebrand,
};
const actions = {
  async showDashboard({ commit }) {
    commit("getdashboard_request");
    const res = await api.get(getdashboard);
    if (res.data.success) {
      commit("getdashboard_success", {
        dashboard: res.data.payload,
        // showTerms: res.data.isShowTermsAndConditions,
      });
    }
    return res;
  },
  async resetDashboardState({ commit }) {
    await commit("resetdashboardstate_success");
  },
  async handleShowRebrand({ commit }, value) {
    commit("update_show_rebrand", value);
  },
};

const mutations = {
  getdashboard_request: (state) => (state.status = "loading"),
  getdashboard_success: (state, { dashboard, showTerms }) => {
    state.status = "success";
    state.dashboard = dashboard;
    // state.isShowTermsAndConditions = showTerms;
  },
  update_show_rebrand: (state, value) => {
    state.showRebrand = value;
  },
  resetdashboardstate_success: (state) =>
    Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
